import React from 'react';
import './ChatHeader.scss';
import { ChatUsers } from './ChatUsers';
import { Icon } from '../icon/Icon';
import { DossierGroup } from '../../models/DossierGroup';
import { DossierMember } from '../../models/DossierMember';
import { User } from '../../models/User';
import classNames from 'classnames';

interface ChatHeaderProps {
  conversation: DossierGroup;
  dossierRelations: DossierMember[];
  className?: string;
  onMobileReturn: () => void;
}

export function ChatHeader(props: ChatHeaderProps): JSX.Element {
  const { conversation, className, onMobileReturn, dossierRelations } = props;
  const { users } = conversation;

  const usersToDossierRelations = (users: User[]): (DossierMember|User)[] => {
    const converted: (DossierMember|User)[] = [];
    for (const user of users) {
      const dossierRelation = dossierRelations?.find(relation => relation.user.match(user));
      converted.push(dossierRelation ?? user);
    }
    return converted;
  };

  return <div className={classNames('chat-header', className)}>
    <button className="chat-header__mobile-return ico-btn" onClick={() => onMobileReturn()} title="Terug naar conversaties">
      <Icon icon="back" />
    </button>
    <ChatUsers className="chat-header__info" members={usersToDossierRelations(users)} dossierGroup={conversation}/>
  </div>;
}
